module.exports = new __parcel__URL__("request-access-lock.c6207860.svg").toString();